import { render } from "./StrategyGetAccessForm.vue?vue&type=template&id=b8b791a8"
import script from "./StrategyGetAccessForm.vue?vue&type=script&lang=js"
export * from "./StrategyGetAccessForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__